module.exports = __webpack_public_path__ + "static/media/ico-shield.d738ab66.svg";